import HeaderBanner from './HeaderBanner';
const Gallery = () => {

    return (
        <>
            <HeaderBanner heading={'OUR HAPPY CLIENTS'} imagePath="assets/images/banners/clietns.avif" />
            <div className="section" style={{ background: 'rgb(235, 230, 230)', paddingTop: '30px', paddingBottom: '30px' }}>
                <div className='center-heading'>
                    <p className="heading-with-border">Our Happy Clients </p>
                </div>
                <div className="container" style={{ width: '100%' }}>
                    <div className="our-client-container">
                        <div className="client-card2">
                            <img src='assets/images/clients/1.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/2.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/3.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/4.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/5.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/6.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/7.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/8.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/9.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/10.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/11.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/12.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/13.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/14.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/15.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/16.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/17.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/18.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/19.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/20.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/21.jpeg' className='client-img' />
                        </div>                    <div className="client-card2">
                            <img src='assets/images/clients/22.jpeg' className='client-img' />
                        </div>                    <div className="client-card2">
                            <img src='assets/images/clients/23.jpeg' className='client-img' />
                        </div>                    <div className="client-card2">
                            <img src='assets/images/clients/24.jpeg' className='client-img' />
                        </div>                    <div className="client-card2">
                            <img src='assets/images/clients/25.jpeg' className='client-img' />
                        </div>                    <div className="client-card2">
                            <img src='assets/images/clients/26.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/27.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/28.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/29.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/30.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/31.jpeg' className='client-img' />
                        </div>
                        <div className="client-card2">
                            <img src='assets/images/clients/32.jpeg' className='client-img' />
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Gallery;